import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-carousel" }

import Controller from './controller.vue';
  import { ref, inject, watchEffect, Ref, reactive, computed } from 'vue';
  import { request } from '@/utils';
  import { ICustomList } from '@/types/custom-list';
  import { FormItem } from '@/types/form';
  import { IBanner } from '@/types/banner';
  import { TImage as TCarouselImage } from '@/components/carousel.vue';

  export interface IForm {
    id?: number;
  }
  export interface IProps {
    props: IForm
    modelValue?: boolean;
  }
  export interface IEmits {
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: IForm): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    props: null,
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: IForm): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    props: IForm
    modelValue?: boolean;
  }

  
  

  const editorMode = inject('editorMode');
  const customList: Ref<ICustomList[]> = inject('banners', ref([]));

  const carouselImages = ref<TCarouselImage[]>([]);

  const form = reactive<IForm>({});
  const formList = computed(() => {
    const list: FormItem[] = [
      customList.value.length && {
        label: 'Select carousel',
        type: 'select',
        key: 'id',
        required: false,
        options: customList.value.map(item => ({ text: item.title, value: item.id }))
      }
    ].filter(Boolean) as FormItem[];
    return list;
  });
  const handleChange = (form: IForm) => {
    emits('change', form);
  };

  watchEffect(async () => {
    const id = props.props.id;
    if (id) {
      form.id = id;
      const { data } = await request.get(`custom_lists/${id}`);
      const banners =  ((data as ICustomList).custom_lists_items || [])
        .map(listItem => listItem.item as IBanner);
      carouselImages.value = banners.map(item => ({
        imageUrl: item.image?.url,
        mobileImageUrl: item.image_mobile?.url,
        link: item.target?.url
      }));
    } else {
      carouselImages.value = [];
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_AppCarousel = _resolveComponent("AppCarousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(editorMode))
      ? (_openBlock(), _createBlock(Controller, {
          key: 0,
          title: "Carousel",
          visible: __props.modelValue,
          "form-list": _unref(formList),
          form: _unref(form),
          "onUpdate:visible": _cache[0] || (_cache[0] = visible => emits('update:modelValue', visible)),
          onChange: handleChange
        }, null, 8, ["visible", "form-list", "form"]))
      : _createCommentVNode("", true),
    (carouselImages.value.length)
      ? (_openBlock(), _createBlock(_component_AppCarousel, {
          key: 1,
          images: carouselImages.value,
          autoplay: ""
        }, null, 8, ["images"]))
      : _createCommentVNode("", true)
  ]))
}
}

})